import React, { useEffect, useState } from 'react';
import CSVReader from 'react-csv-reader';
import { ClassroomToAdd } from 'models/Classroom';

interface Props {
  onChange: (data: ClassroomToAdd[]) => void;
}

const CsvTrainer: React.FC<Props> = ({ onChange }) => {
  const [data, setData] = useState<ClassroomToAdd[]>([]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const formatData = (_data: Array<Array<string>>): void => {
    const newArray = _data.slice(1, _data.length - 1);
    const header = _data[0];
    const formattedData: ClassroomToAdd[] = [];

    newArray.forEach((singleUser: Array<string>) => {
      let classroom = {} as ClassroomToAdd;
      singleUser.forEach((field: string, fieldId: number) => {
        header.forEach((singleHeader: string, headerId: number) => {
          if (
            singleHeader === 'type' ||
            singleHeader === 'name' ||
            singleHeader === 'number' ||
            singleHeader === 'capacity' ||
            singleHeader === 'cost'
          ) {
            if (headerId === fieldId && field) {
              classroom = { ...classroom, [singleHeader]: field };
            }
          }
        });
      });

      formattedData.push(classroom);
    });
    setData(formattedData);
  };

  return (
    <CSVReader
      cssClass="btn btn btn-soft-light"
      onFileLoaded={formatData}
      inputId="ObiWan"
    />
  );
};

export default CsvTrainer;
